var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C4.06667 4.5 1.5 12 1.5 12C1.5 12 3.95 19.5 12 19.5C20.2833 19.5 22.5 12 22.5 12C22.5 12 20.2833 4.5 12 4.5ZM12 16.7833C9.31667 16.7833 7.21667 14.5667 7.21667 12C7.21667 9.43333 9.31667 7.21666 12 7.21666C14.6833 7.21666 16.7833 9.43333 16.7833 12C16.7833 14.5667 14.6833 16.7833 12 16.7833Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.9167C13.6109 14.9167 14.9167 13.6108 14.9167 12C14.9167 10.3892 13.6109 9.08333 12.0001 9.08333C10.3892 9.08333 9.0834 10.3892 9.0834 12C9.0834 13.6108 10.3892 14.9167 12.0001 14.9167Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEye);
export default __webpack_public_path__ + "static/media/Login_Eye.f08e692b74b953c580f57909e0776c74.svg";
export { ForwardRef as ReactComponent };